import { render } from "./ImportacaoExtratoOfxModal.vue?vue&type=template&id=f0983976&scoped=true&ts=true"
import script from "./ImportacaoExtratoOfxModal.vue?vue&type=script&lang=ts"
export * from "./ImportacaoExtratoOfxModal.vue?vue&type=script&lang=ts"

import "./ImportacaoExtratoOfxModal.vue?vue&type=style&index=0&id=f0983976&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0983976"]])

export default __exports__